<template>
  <v-row>
    <v-col>
      <v-img alt="tcdc-branch" :id="branchData.id" :src="branchData.img" aspect-ratio="1.7" class="cursor-pointer mb-1" @click="eventClick">
        <template v-slot:placeholder>
          <v-sheet color="#EFEFEF" class="fill-height"></v-sheet>
        </template>
      </v-img>
      <v-row>
        <v-col>
          <span class="text-uppercase text-tcdc-green sub-header1 bold">{{ branchData.name }}</span>
        </v-col>
        <v-col v-if="branchData.isHighlight" class="text-tcdc-green d-flex flex-1 align-center justify-end">
          <v-tooltip bottom color="rgba(0,0,0,0)" v-for="(item, i) in services" :key="i">
            <template v-slot:activator="{ on }">
              <img
                      v-on="on"
                      alt="tcdc"
                      :src="item.src"
                      loading="lazy"
                      class="branch-card-logo cursor-pointer pr-2"
                      @click="routeTo(item.text)"
              />
            </template>
            <div class="text-tcdc-green bold sub-header1 text-uppercase pt-2">{{item.text}}</div>
          </v-tooltip>
        </v-col>
      </v-row>
      <Divider />
      <v-layout v-if="!branchData.isHighlight" align-center py-2>
        <v-flex class="text-tcdc-green">
          <v-tooltip bottom color="rgba(0,0,0,0)" v-for="(item, i) in returnServices" :key="i">
            <template v-slot:activator="{ on }">
              <img
                  v-on="on"
                  alt="tcdc"
                  :src="item.src"
                  style="width: 46px; height: 25px"
                  loading="lazy"
                  class="branch-card-logo cursor-pointer pr-2"
                  @click="routeTo(item.text)"
              />
            </template>
            <div class="text-tcdc-green bold sub-header1 text-uppercase pt-2">{{item.text}}</div>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <Divider v-if="!branchData.isHighlight" />
    </v-col>
  </v-row>
</template>

<script>
import Divider from "../../components/dividers/Divider";
import { mapState } from 'vuex';
export default {
  props: {
    branchData: {
      default: () => {}
    },
    id : {
      type: Number,
      default: 1
    },
    img : {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ""
    },
    time: {
      type: String,
      default: ""
    },
    place: {
      type: String,
      default: ""
    },
    isHighlight: {
      type: Boolean,
      default: false
    },
    tag: {
      default: 'all'
    }
  },
  components: {
    Divider
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang,
      tagName: state => state.Branch.tag_name
    }),
    returnServices: function () {
      let svc = [ this.services[0] ]
      if (this.branchData.venue_hire.length > 0) svc.push(this.services[1])
      if (this.branchData.membership.length > 0) svc.push(this.services[2])
      return svc
    }
  },
  data: () => ({
    services: [
      {
        src: require('../../assets/icons/sorts/resource_center.png'),
        text: 'Resource Center'
      },
      {
        src: require('../../assets/icons/sorts/venture_hire.png'),
        text: 'Space Rentals'
      },
      {
        src: require('../../assets/icons/sorts/membership.png'),
        text: 'Membership'
      }
    ]
  }),
  methods: {
    routeTo (mode) {
      switch (mode) {
        case 'Resource Center':
          return this.$router.push(`/${this.lang}/${this.branchData.tag}/service/resource-center`);

        case 'Space Rentals':
          return this.$router.push(`/${this.lang}/${this.branchData.tag}/service/venue-hire`);

        case 'Membership':
          return this.$router.push(`/${this.lang}/${this.branchData.tag}/service/membership`);

      }
    },
    eventClick() {
      this.$emit('onClick');
    }
  }
};
</script>

<style>
.branch-card-logo {
  height: 25px;
  object-fit: contain;
}
</style>
